module.exports = __webpack_public_path__ + "img/bg_donation.6d92123c.png";